// COMO A REPUTAÇÃO APARECE NA TELA (20/09/2026).
//
// 🐛 O BUG QUE ORIGINOU ISTO: a coluna "Reputação" do mural mostrava **0.0** para empresa sem nenhuma
// avaliação — `Number(v.empresaScore || 0).toFixed(1)`. Lojas Torra, que nunca foi avaliada por ninguém,
// aparecia com nota ZERO ao lado do nome, em três telas diferentes. Para quem lê, "0.0" é a pior nota
// possível, não "ainda não sabemos": o portal estava difamando quem não tinha feito nada.
//
// É o mesmo erro de 28/08 (carimbar sem amostra) voltando pela porta da FORMATAÇÃO, não do cálculo.
// A regra aqui é uma só: SEM AVALIAÇÃO NÃO EXISTE NOTA. Não existe zero, não existe traço disfarçado
// de número — existe a frase "sem avaliações".
//
// As palavras acompanham os três baldes que ordenam o mural (ver BaldeDoSelo no VagaEndpoints.cs), para
// a tela explicar a ordem em que ela mesma está: recomendada → sem avaliações → não recomendada.
const SELO_COR = {
  ra:   "bg-green-100 text-green-800",
  good: "bg-blue-100 text-blue-800",
  mid:  "bg-yellow-100 text-yellow-800",
  bad:  "bg-red-100 text-red-800",
  none: "bg-gray-100 text-gray-600",
};

/**
 * Traduz a reputação de uma empresa para o que a tela mostra.
 * @returns {{nota: string|null, rotulo: string, cor: string, titulo: string}}
 *   `nota` é null quando NÃO HÁ avaliação — nesse caso a tela mostra só o rótulo, nunca um número.
 */
export function reputacaoDaEmpresa(score, selo, classificacao) {
  const cor = SELO_COR[selo] || SELO_COR.none;

  // Sem amostra: não há número a mostrar. Nem 0,0, nem a média neutra — nada.
  if (selo === "none" || score == null) {
    return {
      nota: null,
      rotulo: "sem avaliações",
      cor: SELO_COR.none,
      titulo: "Nenhum candidato avaliou esta empresa ainda. Sem avaliação não existe nota.",
    };
  }

  const nota = Number(score).toFixed(1).replace(".", ",");

  if (selo === "ra") return { nota, rotulo: "Selo eaiRH", cor, titulo: `Selo eaiRH — nota ${nota}.` };
  if (selo === "good") return { nota, rotulo: "recomendada", cor, titulo: `Nota ${nota}, com avaliações suficientes para afirmar.` };
  if (selo === "bad") return { nota, rotulo: "não recomendada", cor, titulo: `Nota ${nota}, com avaliações suficientes para afirmar.` };

  // "mid" cobre dois casos diferentes, e a palavra do backend já distingue: "Poucas avaliações" (1 ou 2,
  // a nota aparece mas a conclusão ainda não) e "Regular" (amostra cheia, empresa mediana mesmo).
  const rotulo = (classificacao || "Regular").toLowerCase();
  return {
    nota,
    cor,
    rotulo,
    titulo: rotulo.startsWith("poucas")
      ? `Nota ${nota}, mas com 1 ou 2 avaliações — pouco para afirmar qualquer coisa.`
      : `Nota ${nota}.`,
  };
}

/** Versão de uma linha só, para chips (celular e página da vaga). */
export function reputacaoEmLinha(score, selo, classificacao) {
  const r = reputacaoDaEmpresa(score, selo, classificacao);
  return { ...r, texto: r.nota ? `reputação ${r.nota} · ${r.rotulo}` : r.rotulo };
}
